export default "__VITE_ASSET__f5acedb2__"